export default {"src":"/_next/static/media/instant_personal_loan_logo.041fe52c.svg","height":100,"width":152,"blurWidth":0,"blurHeight":0};